import { useEffect, useState } from "react";

/**
 * Tracks the real viewport height and sets the --vh CSS variable
 * so mobile browsers render 100vh correctly.
 */
export function useRealViewportHeight() {
  const [vh, setVh] = useState(0);

  useEffect(() => {
    const set = () => {
      const height = window.innerHeight || document.documentElement.clientHeight;
      document.documentElement.style.setProperty("--vh", `${height * 0.01}px`);
      setVh(height);
    };

    set();
    window.addEventListener("resize", set);
    window.addEventListener("orientationchange", set);

    return () => {
      window.removeEventListener("resize", set);
      window.removeEventListener("orientationchange", set);
    };
  }, []);

  return vh;
}
